import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "./../commonBaseApiSlice";

export const sensorApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSensor: builder.mutation({
      query: (data) => ({
        url: `/sensors/getsensorsbytenantid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    createSensor: builder.mutation({
      query: (Data: any) => ({
        url: `/sensors/create`,
        method: "POST",
        body: Data,
      }),
    }),
    editSensor: builder.mutation({
      query: (Data: any) => ({
        url: `/sensors/edit`,
        method: "PUT",
        body: Data,
      }),
    }),
    startSensor: builder.mutation({
      query: (data) => ({
        url: `/sensors/start?${getFilters(data)}`,
        method: "POST",
      }),
    }),
    stopSensor: builder.mutation({
      query: (data) => ({
        url: `/sensors/stop?${getFilters(data)}`,
        method: "POST",
      }),
    }),
    enrollSensor: builder.mutation({
      query: (data) => ({
        url: `/sensors/enroll?${getFilters(data)}`,
        method: "PATCH",
      }),
    }),
    unEnrollSensor: builder.mutation({
      query: (data) => ({
        url: `/sensors/unenroll?${getFilters(data)}`,
        method: "PATCH",
      }),
    }),
    getSensorLogs: builder.mutation({
      query: (data) => ({
        url: `/sensors/log?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getRetrieveFromZebra: builder.mutation({
      query: (data) => ({
        url: `/sensors/retrivefromzebra?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getRetrieveFromMonnit: builder.mutation({
      query: (data) => ({
        url: `sensors/retrivefrommonnit?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    exportSensorLogs: builder.mutation({
      query: (data) => ({
        url: `/sensors/log/export?${getFilters(data)}`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    getSensorsLog: builder.mutation({
      query: (data) => ({
        url: `/sensorslog/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getRefrigeratorLogsReport: builder.mutation({
      query: (data) => ({
        url: `/refrigerators/logsreport?${getFilters(data)}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useGetSensorMutation,
  useCreateSensorMutation,
  useEditSensorMutation,
  useStartSensorMutation,
  useStopSensorMutation,
  useEnrollSensorMutation,
  useUnEnrollSensorMutation,
  useGetSensorLogsMutation,
  useGetRetrieveFromZebraMutation,
  useGetRetrieveFromMonnitMutation,
  useExportSensorLogsMutation,
  useGetSensorsLogMutation,
  useGetRefrigeratorLogsReportMutation,
} = sensorApiSlice;
